module.exports = __webpack_public_path__ + "img/video-empty.4a7b2f23.png";